var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.348,178.087h-16.696V116.87C439.652,52.428,387.224,0,322.783,0H189.217c-64.442,0-116.87,52.428-116.87,116.87    v61.217H55.652c-27.618,0-50.087,22.469-50.087,50.087v68.276c0,17.27,15.534,31.254,33.391,28.257v103.815    c0,46.03,37.448,83.478,83.478,83.478h267.13c46.03,0,83.478-37.448,83.478-83.478V324.707    c17.761,2.981,33.391-10.883,33.391-28.258v-68.275C506.435,200.556,483.966,178.087,456.348,178.087z M105.739,116.87    c0-46.03,37.448-83.478,83.478-83.478h133.565c46.03,0,83.478,37.448,83.478,83.478v61.217H105.739V116.87z M122.435,478.609    c-27.618,0-50.087-22.469-50.087-50.087v-16.696h50.087V478.609z M122.435,378.435H72.348V300.03    c8.328-3.381,18.424-1.595,25,5.92c6.772,7.739,15.482,13.344,25.087,16.374V378.435z M239.304,478.609h-83.478v-66.783h83.478    V478.609z M239.305,378.435h-0.001h-83.478v-56.111c9.604-3.03,18.314-8.634,25.087-16.374c8.822-10.083,24.465-10.104,33.306,0    c6.772,7.739,15.482,13.344,25.087,16.374V378.435z M356.174,478.609h-83.478v-66.783h83.478V478.609z M356.175,378.435h-0.001    h-83.478v-56.111c9.604-3.03,18.314-8.634,25.087-16.374c8.822-10.083,24.465-10.104,33.306,0    c6.772,7.739,15.482,13.344,25.087,16.374V378.435z M439.652,428.522c0,27.618-22.469,50.087-50.087,50.087v-66.783h50.087    V428.522z M439.652,378.435h-50.087v-56.111c9.604-3.03,18.314-8.634,25.087-16.374c6.55-7.486,16.637-9.316,25-5.92V378.435z     M473.043,283.913c-22.113-25.213-61.424-25.203-83.522,0.049c-8.822,10.083-24.465,10.104-33.306,0    c-22.117-25.277-61.468-25.253-83.564,0c-8.822,10.083-24.465,10.104-33.306,0c-22.117-25.277-61.468-25.253-83.564,0    c-8.822,10.083-24.465,10.104-33.306,0c-22.085-25.239-61.398-25.273-83.521-0.049v-55.739c0-9.206,7.49-16.696,16.696-16.696    c32.61,0,385.558,0,400.696,0c9.206,0,16.696,7.49,16.696,16.696V283.913z",
    fill: "#283159",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.f6964cc03f6ad66cb8c0414f34a0b02b.svg";
export { ForwardRef as ReactComponent };